// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-card-title {
  display: flex;
  justify-content: space-between;
}

.profile-image {
  width: 60px;
  height: 60px;
  border: 1px solid var(--ion-color-primary);
  background-color: white;
  overflow: hidden;
  position: relative;
}
.profile-image h2 {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 100%;
  width: 100%;
  height: 100%;
  margin: 0;
  color: var(--ion-color-primary);
}

.team-member {
  position: relative;
}
.team-member-badge {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  z-index: 10;
  border-radius: 10px;
  content: "";
}
.team-member-badge--available {
  background-color: var(--ion-color-success-tint);
  border: 2px solid var(--ion-color-success-shade);
}
.team-member-badge--offline {
  background-color: var(--ion-color-danger-tint);
  border: 2px solid var(--ion-color-danger-shade);
}

.team-members {
  display: flex;
  gap: 8px;
}

.flex {
  display: flex;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ax-tagesuebersicht-card/ax-tagesuebersicht-card.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,+BAAA;AACJ;;AAGA;EACE,kBAAA;AAAF;AAEE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;AAAJ;AAEI;EACE,+CAAA;EACA,gDAAA;AAAN;AAGI;EACE,8CAAA;EACA,+CAAA;AADN;;AAMA;EACE,aAAA;EACA,QAAA;AAHF;;AAMA;EACE,aAAA;EACA,8BAAA;AAHF","sourcesContent":["ion-card-title {\n  display: flex;\n  justify-content: space-between;\n}\n\n.profile-image {\n  width: 60px;\n  height: 60px;\n  border: 1px solid var(--ion-color-primary);\n  background-color: white;\n  overflow: hidden;\n  position: relative;\n\n  h2 {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    line-height: 100%;\n    width: 100%;\n    height: 100%;\n    margin: 0;\n    color: var(--ion-color-primary);\n  }\n}\n\n.team-member {\n  position: relative;\n\n  &-badge {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 20px;\n    height: 20px;\n    z-index: 10;\n    border-radius: 10px;\n    content: '';\n\n    &--available {\n      background-color: var(--ion-color-success-tint);\n      border: 2px solid var(--ion-color-success-shade);\n    }\n\n    &--offline {\n      background-color: var(--ion-color-danger-tint);\n      border: 2px solid var(--ion-color-danger-shade);\n    }\n  }\n}\n\n.team-members {\n  display: flex;\n  gap: 8px;\n}\n\n.flex {\n  display: flex;\n  justify-content: space-between;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
